import { EntitlementsActionTypes, CurrentUserRoleActionTypes, Entitlements, CurrentUserRole, EntitlementNames, CurrentUserRoleNames } from './types';

const initialState: Entitlements = {
  authorizations: null,
  loading: true,
  error: false,
};

export const entitlementsReducer = (
  state: Entitlements = initialState,
  action: EntitlementsActionTypes,
): Entitlements => {
  switch (action.type) {
    case EntitlementNames.SET_AUTHORIZATIONS: {
      return {
        ...state,
        authorizations: action.payload,
      };
    }
    case EntitlementNames.SET_LOADING: {
      return {
        ...state,
        loading: action.payload,
      };
    }
    case EntitlementNames.SET_ERROR: {
      return {
        ...state,
        error: action.payload,
      };
    }
    default:
      return state;
  }
};

const initialStateCurrentUserRole: CurrentUserRole = {
  userRoleName: "",
  loading: true,
  error: false,
};

export const currentRoleReducer = (
  state: CurrentUserRole = initialStateCurrentUserRole,
  action: CurrentUserRoleActionTypes,
): CurrentUserRole => {
  switch (action.type) {
    case CurrentUserRoleNames.SET_CURRENT_USER_ROLE: {
      return {
        ...state,
        userRoleName: action.userRoleName,
      };
    }
    case CurrentUserRoleNames.SET_CURRENT_USER_ROLE_LOADING: {
      return {
        ...state,
        loading: action.loading,
      };
    }
    case CurrentUserRoleNames.SET_CURRENT_USER_ROLE_ERROR: {
      return {
        ...state,
        error: action.error,
      };
    }
    default:
      return state;
  }
};